import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    downloadMac: string;
    downloadWindows: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** CTA to download for macOS */
            downloadMac: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GetDriveDownloadUrl.downloadMac?c=33wyg24yo58zh", defaultMessage: "Get macOS app" }));
                },
                enumerable: true,
                configurable: true
            },
            /** CTA to download for Windows */
            downloadWindows: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "GetDriveDownloadUrl.downloadWindows?c=7vickj5ek719", defaultMessage: "Get Windows app" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
